import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Backup/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import BackupTable from 'components/Web_User_Interface/1440p_Series/System/Backup/backupTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  SuccessBox,
  PermissionBox,
  BackupTable,
  BreadCrumbs,
  SEOHelmet,
  React
};